import script from "./deboneReport.vue?vue&type=script&setup=true&lang=js"
export * from "./deboneReport.vue?vue&type=script&setup=true&lang=js"

import "./deboneReport.vue?vue&type=style&index=0&id=7bf97d87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf97d87"]])

export default __exports__